import { useSchoolYear } from '@pelckmans/business-components/context/SchoolYearContext';
import ListGroup from '@pelckmans/elementis/components/list-group';
import Section from '@pelckmans/elementis/components/section';
import { useTranslation } from 'react-i18next';
import LoadingState from '../../../shared-components/LoadingState';
import AcceptedList from '../components/AcceptedList';
import useStudentGroups from '../hooks/useStudentGroups';
import { toId } from '../utils';
import { useContext } from 'react';
import InvitationContext from '../../../contexts/InvitationContext';
import EmptyState from '../../../shared-components/EmptyState';
import AccountContext from '../../../contexts/AccountContext';

export default function PreviousYearTab() {
  const { t } = useTranslation();
  const { previousSchoolYear } = useSchoolYear();

  const { loading, groups } = useStudentGroups(toId(previousSchoolYear!));
  const { pendingInvitations } = useContext(InvitationContext);

  const { account } = useContext(AccountContext);

  if (loading || !previousSchoolYear)
    return <LoadingState variant="list" aria-label={t('PAGES.MY_TEACHERS.PREVIOUS_YEAR_TAB.LOADING.A11Y_LABEL')} />;

  const personalGroups = groups?.filter(group => !group.smartschoolGroupId);
  const smartschoolGroups = groups?.filter(group => group.smartschoolGroupId);

  if (personalGroups.length === 0 && smartschoolGroups.length === 0 && pendingInvitations.length === 0) {
    return (
      <Section
        title={t('PAGES.MY_TEACHERS.PREVIOUS_YEAR_TAB.TITLE', {
          schoolYearStartYear: previousSchoolYear.from.getFullYear(),
          schoolYearEndYear: previousSchoolYear.to.getFullYear(),
        })}
      >
        <EmptyState
          variant="list"
          headerTitle={t('PAGES.MY_TEACHERS.PREVIOUS_YEAR_TAB.EMPTY.TITLE')}
          bodyText={t('PAGES.MY_TEACHERS.PREVIOUS_YEAR_TAB.EMPTY.BODY')}
        />
      </Section>
    );
  }

  return (
    <Section
      title={t('PAGES.MY_TEACHERS.PREVIOUS_YEAR_TAB.TITLE', {
        schoolYearStartYear: previousSchoolYear.from.getFullYear(),
        schoolYearEndYear: previousSchoolYear.to.getFullYear(),
      })}
    >
      <ListGroup>
        <AcceptedList
          schoolYear={toId(previousSchoolYear)}
          headerTitle={t('PAGES.MY_TEACHERS.ACCEPTED_LIST.TITLE')}
          headerTooltip={t('PAGES.MY_TEACHERS.ACCEPTED_LIST.TOOLTIP')}
          groups={personalGroups}
        />
        {account.smartschoolSchools.length !== 0 && (
          <AcceptedList
            schoolYear={toId(previousSchoolYear)}
            headerTitle={t('PAGES.MY_TEACHERS.ACCEPTED_LIST.TITLE_SMARTSCHOOL')}
            headerTooltip={t('PAGES.MY_TEACHERS.ACCEPTED_LIST.TOOLTIP')}
            groups={smartschoolGroups}
          />
        )}
      </ListGroup>
    </Section>
  );
}
